import { isUndefined } from 'lodash'
import { asString } from 'ol/color'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'

const fillMap = ((fillColor, strokeColor, strokeWidth = 2) => {
    if (isUndefined(fillColor) || isUndefined(strokeColor)) {
        return [new Style()]
    }
    const fill = new Fill({
        color: asString(fillColor),
    })
    const stroke = new Stroke({
        color: asString(strokeColor),
        width: strokeWidth,
    })
    return [
        new Style({
            fill,
            stroke,
        }),
    ]
})

export default fillMap